import store from '@/store'

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission (value) {
  if (value && value instanceof Array && value.length > 0) {
    const roleId = store.getters && store.getters.userInfo.roleId
    const permissionRoles = value
    const roleIdList = [ roleId ]
    const hasPermission = roleIdList.some(role => {
      return permissionRoles.includes(role)
    })

    if (!hasPermission) {
      return false
    }
    return true
  } else {
    console.error(`need roles! Like v-permission="['admin','editor']"`)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/utils/permission.js